import React, { Dispatch } from 'react';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Log } from 'ng2-logger';
import Flatpickr from 'react-flatpickr';
import { Redirect } from 'react-router-dom';

import { Turkish } from 'flatpickr/dist/l10n/tr';
import english from 'flatpickr/dist/l10n/default';
import Translator from '../../core/i18n';

import * as actionTypes from '../../models/action/calendar';
import * as calendarPageAction from '../../store/actions/calendar';

import '../../scss/bootstrap-datetimepicker.scss';
import '../../scss/calendar.scss';
import '../../scss/fullcalendar.min.scss';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import 'moment/locale/ar';

import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import ReactGA from 'react-ga4';

interface ICalendarState {
    view: 'day' | 'month' | 'week';
    datas: actionTypes.ICalendarData[];
    date: Date;
    filter: actionTypes.IFilter;
    redirect: boolean;
    redirectUrl: string;
}

interface ICalendarProps {
    dispatch?: any;
    mode?: 'single' | 'multiple' | 'range' | 'time' | null;
    calendarDatas?: actionTypes.ICalendarData[];
}

const T = Translator.create();
const localizer = momentLocalizer(moment);
if (T.i18next.language === 'tr') {
    moment.locale('tr');
} else if (T.i18next.language === 'en') {
    moment.locale('en');
}
else if (T.i18next.language === 'ar') {
    moment.locale('ar');
}

const _logger = Log.create('Calendar');
const _dateFormat = window.appSettings.DefaultDateFormatApi.split(' ')[0];
const _formats = {
    weekdayFormat: (date: any, culture: any, localizer1: any) => localizer.format(date, 'dddd', culture)
};

class CalendarMain extends React.Component<ICalendarProps, ICalendarState> {
    public picker: HTMLDivElement | null = null;
    constructor(props: any) {
        super(props);

        this.state = {
            view: 'month',
            datas: [],
            date: new Date(moment().toString()),
            filter: { activityTypes: [ActivityTypeEnums.VirtualClass, ActivityTypeEnums.Assignment, ActivityTypeEnums.Exam, ActivityTypeEnums.Forum, ActivityTypeEnums.Video, ActivityTypeEnums.Elesson, ActivityTypeEnums.Document] },
            redirect: false,
            redirectUrl: '/'
        };
    }

    componentDidMount = () => {
        this.getDatas(moment(), 'monthly');
    };

    componentDidUpdate = (prevProps: ICalendarProps) => {
        if (prevProps.calendarDatas !== this.props.calendarDatas) {
            const _calendarDatas: actionTypes.ICalendarData[] = [];
            if (this.props.calendarDatas) {
                this.props.calendarDatas.forEach(data => {
                    _calendarDatas.push({
                        title: data.title,
                        start: new Date(data.start),
                        end: new Date(data.end),
                        type: data.type.toString(),
                        classId: data.classId,
                        courseId: data.courseId,
                        termWeekId: data.termWeekId,
                        activityId: data.activityId
                    });
                });
            } 

            this.setState({ datas: _calendarDatas });
        }
    };

    onDayChange = (dates: Date[], currentDateString: string, self: any) => {
        const currentDate = moment(currentDateString);
        this.setState({ date: new Date(currentDate.format(_dateFormat)) });
    };

    onMonthOrYearChange = (dates: Date[], currentDateString: string, self: any) => {

        self.currentYear = Number(self.currentYear.toString().replace(/[^0-9]/g, ''));

        if(self.currentYear && self.currentYear<2015)
        {
            self.currentYear = 2015;
        }

        if(self.currentYear.toString().length > 4)
         {
            self.currentYear = Number(self.currentYear.toString().substring(0, 4));
         }
        const currentDate = moment(self.currentYear + '-' + (self.currentMonth + 1) + '-' + 1);
        this.setState({ date: new Date(currentDate.format(_dateFormat)) });

        this.getDatas(currentDate, 'monthly');
    };

    getDatas = (currentDate: moment.Moment, changeType: string) => {
        let startDate;
        let endDate;

        if (changeType === 'monthly') {
            startDate = moment(
                currentDate.format('YYYY') + '-' + currentDate.format('MM') + '-' + 1 + ' 00:00',
                window.appSettings.DefaultDateFormatApi
            );
            let startDateDayOfWeek = startDate.day();
            if (startDateDayOfWeek === 0) {
                startDateDayOfWeek = 7;
            } 
            startDate = moment(startDate).add(1 - startDateDayOfWeek, 'd');

            endDate = moment(
                currentDate.format('YYYY') + '-' + currentDate.format('MM') + '-' + currentDate.endOf('month').format('DD') + ' 00:00',
                window.appSettings.DefaultDateFormatApi
            );
            let endDateDayOfWeek = endDate.day();
            if (endDateDayOfWeek === 0) {
                endDateDayOfWeek = 7;
            } 
            endDate = moment(endDate).add(8 - endDateDayOfWeek, 'd');
        }

        if (startDate && endDate) {

            this.props.dispatch(calendarPageAction.GetCalendarData(startDate, endDate, this.state.filter));
        }
    };

    onTypeChange = (type: 'day' | 'month' | 'week') => {

        if (type == 'day')
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_CALENDAR_DAY_CLICKED',
                label:'G_CALENDAR_DAY_CLICKED', 
                nonInteraction: true, 
              });  
        }
        else  if (type == 'month')
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_CALENDAR_MONTH_CLICKED',
                label:'G_CALENDAR_MONTH_CLICKED', 
                nonInteraction: true, 
              });  
        }
        else  if (type == 'week')
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_CALENDAR_WEEK_CLICKED',
                label:'G_CALENDAR_WEEK_CLICKED', 
                nonInteraction: true, 
              });  
        }

        this.setState({ view: type });
    };

    onClickFilter = (event: any, type: ActivityTypeEnums) => {
        if (event && event.target) {

            const _filter = this.state.filter;
            const _filterIndex = _filter.activityTypes.indexOf(type);
            ReactGA.event({
                category: window.location.host,
                action: 'G_CALENDAR_FILTER_'+type+'_CLICKED',
                label:'G_CALENDAR_FILTER_'+type+'_CLICKED',
                nonInteraction: true, 
              }); 
            if (event.target.checked && _filterIndex === -1) {
                _filter.activityTypes.push(type);
            } else if (!event.target.checked && _filterIndex !== -1) {
                _filter.activityTypes.splice(_filterIndex, 1);
            }

            this.setState({ filter: _filter });
            this.getDatas(moment(this.state.date), 'monthly');       
        }
    };

    calendarEvent =  (event: any, children: any) => {
        let colorClass = '';
        switch (event.type) {
            case '2':
                colorClass = 'colorDers';
                break;
            case '4':
                colorClass = 'colorViewing';
                break;
            case '5':
                colorClass = 'colorSanal';
                break;
            case '6':
                colorClass = 'colorToplanti';
                break;
            case '7':
                colorClass = 'colorDocument';
                break;
            case '8':
                colorClass = 'colorOgrenci';
                break;
            case '11':
                colorClass = 'colorCustom';
                break;
        }

        const style = 
            children && children.props && children.props.style ? 
            children.props.style : undefined;

        return (           
            <div
                className={'fc-event ' + colorClass +  ' _' + event.type}
                style={style}
                data-redirectLink={'u/course?classId=' + event.classId + '&activityId=' + event.courseId + '&type=1' +'&actid=' + event.activityId + '&weekorunitid=' + event.termWeekId}
                onClick={this.redirectActivity}
                title={event.title}
                aria-hidden="true"
            >
                <div style={{cursor:'pointer'}} className="fc-content fc-content-custom-2">
                    {event.type === '4' || event.type === '6' || event.type === '11' || event.type === '7' ? (
                        moment(event.end).format('HH:mm') + ' : ' + event.title
                    ) : (
                        moment(event.start).format('HH:mm') + ' - ' +  moment(event.end).format('HH:mm') + ' : ' + event.title
                    )}
                </div>
            </div>
        );
    }

    onShowMore = (events: any, date: Date) => {
        this.setState({ date, view: 'day' });
        if (this.state.date.getMonth() !== date.getMonth()) {
            this.getDatas(moment(date), 'monthly');     
        }
    }

    redirectActivity = (event: any) => {
        if (event && event.currentTarget) {
            this.setState({redirect: true, redirectUrl: event.currentTarget.getAttribute('data-redirectLink')});
        }
    }

    public render() {
        if(this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }

        return (
            <div className="container-fluid">
                <div className="row ">
                    <div className=" sidebar px-0" style={{width:'320px' }}>
                        <div className="calendar1-title">
                            <div className="tittle-text">{T.t('r_menu_calendar')}</div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12">
                                <div className="calendar calendar-first " id="calendar-picker">
                                    <Flatpickr
                                        options={{
                                            allowInput: true,
                                            inline: true,
                                            locale: T.i18next.language === 'tr' ? Turkish : english,
                                            mode: this.props.mode ? this.props.mode : 'single'
                                        }}
                                        onChange={this.onDayChange}
                                        onMonthChange={this.onMonthOrYearChange}
                                        onYearChange={this.onMonthOrYearChange}
                                        value={this.state.date}
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-12 p-10" style={{ marginTop: '40px' }}>
                                        <label className="px-10" htmlFor="calendar_view">
                                            {T.t('r_gen_filter_activityType_2')}
                                        </label>
                                        <div className="check-boxes p-10">
                                            <label className="check-container ">
                                                {T.t('r_activity_type_VirtualClass')}
                                                <input
                                                    // tslint:disable-next-line: jsx-no-lambda
                                                    onChange={e => this.onClickFilter(e, ActivityTypeEnums.VirtualClass)}
                                                    className="check-filter filter"
                                                    type="checkbox"
                                                    defaultChecked={true}
                                                />
                                                <span className="checkmark-blue" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Assignment')}
                                                <input
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Assignment)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-green" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Exam')}
                                                <input 
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Exam)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-purple" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Video')}
                                                <input 
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Video)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-yellow" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Forum')}
                                                <input 
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Forum)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-orange" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Elesson')}
                                                <input 
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Elesson)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-pink" />
                                            </label>

                                            <label className="check-container">
                                                {T.t('r_activity_type_Document')}
                                                <input 
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Document)}
                                                className="check-filter filter" type="checkbox" defaultChecked={true} />
                                                <span className="checkmark-document" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" alms-background  content" style={{width:'Calc(100% - 320px)'}}>
                        <div id="contextMenu" className="dropdown clearfix" />
                        <div id="wrapper" className="print-visible fc fc-unthemed fc-ltr">
                            <div className="fc-toolbar fc-header-toolbar">
                                <div className="fc-left" />
                                <div className="fc-right">
                                   {/* <button
                                        type="button"
                                        className="fc-dotButton-button fc-button fc-state-default fc-corner-left fc-corner-right"
                                        aria-label="dotButton"
                                    >
                                        <span className="fc-icon fc-icon-print" />
                                    </button>*/}
                                </div>
                                <div className="fc-center">
                                    <div className="fc-button-group">
                                        <button
                                            onClick={this.onTypeChange.bind(this, 'day')}
                                            type="button"
                                            className={
                                                'fc-agendaDay-button fc-button fc-corner-left' +
                                                (this.state.view === 'day' ? ' fc-state-active' : ' fc-state-default')
                                            }
                                            style={{ border: 0 }}
                                        >
                                            {T.t('r_time_day')}
                                        </button>
                                        <button
                                            onClick={this.onTypeChange.bind(this, 'week')}
                                            type="button"
                                            className={
                                                'fc-agendaWeek-button fc-button' +
                                                (this.state.view === 'week' ? ' fc-state-active' : ' fc-state-default')
                                            }
                                            style={{ border: 0 }}
                                        >
                                            {T.t('r_time_week')}
                                        </button>
                                        <button
                                            onClick={this.onTypeChange.bind(this, 'month')}
                                            type="button"
                                            className={
                                                'fc-month-button fc-button fc-corner-right' +
                                                (this.state.view === 'month' ? ' fc-state-active' : ' fc-state-default')
                                            }
                                            style={{ border: 0 }}
                                        >
                                            {T.t('r_time_month')}
                                        </button>
                                    </div>
                                </div>
                                <div className="fc-clear" />
                            </div>
                            <div className="print-visible calendar-custom" id="calendar">
                                <Calendar
                                    localizer={localizer}
                                    culture={T.i18next.language}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 'Calc(100vh - 76px - 70px)' }}
                                    toolbar={false}
                                    formats={_formats}
                                    defaultView="month"
                                    view={this.state.view}
                                    events={this.state.datas}
                                    date={this.state.date}
                                    // tslint:disable-next-line
                                    onView={() => {}}
                                    // tslint:disable-next-line
                                    onSelectEvent={() => {}}
                                    components={{
                                        eventWrapper: ({ event, children }) => (
                                            this.calendarEvent(event, children)
                                          )
                                    }}
                                    onShowMore={this.onShowMore}
                                    messages={{
                                        showMore: (count: number) => {
                                          return (T.i18next.language!= 'ar')? '+' + count + ' ' +T.t('r_gen_more'): T.t('r_gen_more') + ' +' + count ;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICalendarProps): ICalendarProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ICalendarProps = Object.assign({}, ownProps, {
        calendarDatas: state.calendar.calendarDatas
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.calendar.calendarDatas === prev.calendar.calendarDatas;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CCalendarMain = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CalendarMain);

export default CCalendarMain;
